export const SET_APP_FILTER = '@app-filters/add-filter';
export function setAppFilter(values) {
  return dispatch => {
    dispatch({
      type: SET_APP_FILTER,
      payload: values
    });
  };
}
